import { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import { proposalService, mprService } from '../../../Services';
import { proposalActions, mprActions } from '../../../Actions';
import { useDispatch, useSelector } from 'react-redux';

const Lsit = () => {
  const auth = useSelector((state) => state.auth);
  const proposal = useSelector((state) => state.proposal);
  const mpr = useSelector((state) => state.mpr);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [te, setTE] = useState([]);

  const mprIdRef = useRef();
  const monthNumberRef = useRef();

  useEffect(() => {
    proposalService.list().then(res => {
      if(res.status == 401) {
        navigate("/logout");
      }
      let proposal = res.data.proposals[0] ?? [];
      localStorage.setItem("proposal", JSON.stringify(proposal));
      dispatch(proposalActions.proposal(proposal));
      return res.data.proposals[0];
    }).then(res => {    
      mprService.list(res.id).then(res => {
        return res.data.list;
      }).then(mpr => {
      mpr.map((val, key) => {
        mprService.te(val.id).then(res => {
          mpr[key].te = res.data.te;
          localStorage.setItem("mpr", JSON.stringify(mpr));
        });
      });
      localStorage.setItem("mpr", JSON.stringify(mpr));
      dispatch(mprActions.mpr(mpr));
    });    
    });    
  }, []);

  const [submitted, setSubmitted] = useState(false);
  const [file, setFile] = useState('');
  const [fileSize, setFileSize] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);

  const handleChange = (e) => {
    setFile(e.target.files);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setFileSize(true);
    setSubmitted(true);
    submitForm();
  }

  const deleteMPR = (mpr_id) => {
    mprService.mprDelete(mpr_id).then(res => {
      const mpr = res.data;
      localStorage.setItem("mpr", JSON.stringify(mpr));
      dispatch(mprActions.mpr(mpr));
      setSubmitted(false);
      setFile(null);
    });
  } 

  const submitForm = () => {
    const formData = new FormData();
    formData.append('submit_status', 1);
    formData.append('app_id', proposal.id);
    formData.append('mpr_id', mprIdRef.current.value);
    formData.append('month_number', monthNumberRef.current.value);
    
    if (file &&file[0].size > 10240000){
      setFileSize(false);
      setSubmitted(false);
      return;
    }
    formData.append('doc', file[0]);
    
    mprService.mprSave(formData).then(res => {
      if(res.status == 1) {
        const mpr = res.data;
        localStorage.setItem("mpr", JSON.stringify(mpr));
        dispatch(mprActions.mpr(mpr));
      }
      setSubmitted(false);
    });
  }

  const TEModal = () => {
    return (
      <>
        <div className={"modal fade"} id="TEModal">
          <div className="modal-dialog modal-dialog-scrollable modal-xl">
            <div className="modal-content">
            
              <div className="modal-header">
                <h4 className="modal-title">Technical expert comment for {te[0]?.month_name} month's progress report</h4>
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
                <div>
                  <table className='table'>
                    <tbody>
                      {
                        te && te.map(val => 
                          <tr>
                            <td>
                              <h5>{val.title+" "+val.full_name}</h5>
                              <p>{val.comment}</p>
                            </td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }

  const DocModal = () => {
    return (
      <>
        <div className={"modal fade"} id="DocModal">
          <div className="modal-dialog modal-dialog-scrollable modal-lg">
            <div className="modal-content">
            
              <div className="modal-header">
                <h4 className="modal-title">{modalTitle}</h4>
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
                {selectedFile && 
                <>
                  {/* <iframe src={process.env.REACT_APP_PUBLIC_URL+"/uploads"+selectedFile} width={"100%"} height={"500px"} /> */}
                  <DocViewer
                    pluginRenderers={DocViewerRenderers} 
                    documents={
                      [
                        { uri: process.env.REACT_APP_PUBLIC_URL+"/uploads"+selectedFile },
                        // { uri: require(selectedFile) }, // Local File
                      ]
                    }
                    config={{
                      header: {
                        disableFileName: true,
                        "Access-Control-Allow-Origin": "*",
                      }
                    }} 
                  />
                </>
                }
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }
  
  return (
    <>
      <div className="card border-success">
        <div className="card-header bg-light p-2 border-success" style={{"borderTop": "3px solid"}}><h6>Application ID: {proposal.registerNumber} - Monthly Progress Reports</h6></div>
        <div className="card-body">
          <table className='table'>
            {
              proposal.sid==13 && mpr.length > 0 ?
              <tbody>
                {mpr.map((val, key) => (
                  <tr key={key}>
                    <td width={"40%"}>
                      {val.month_name} progress report
                    </td>
                    <td className='text-left'>
                      {(val.month_number == 1 || mpr[key-1].admin_status == 1) && (
                        val.doc? 
                        <FontAwesomeIcon icon={faFileAlt} className='pointer text-primary' style={{height: "30px"}} data-toggle="modal" data-target="#DocModal" onClick={() => {setSelectedFile(val.doc); setModalTitle(val.month_name);}} />
                        :
                        <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                            <p>Maximum file size: 10MB</p>
                            <input type='hidden' name='mpr_id' value={val.id} ref={mprIdRef} />
                            <input type='hidden' name='month_number' value={val.month_number} ref={monthNumberRef} />
                            <input type="file" className='custom-file-input1' id="customFile" name='utilization_certificate' onChange={handleChange} />
                            {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                            {!fileSize && <p style={{color:'red'}}>File size should not be greater than 10MB!</p>}
                            <button type="submit" className="btn btn-sm btn-info">
                            {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Upload</span>}
                            </button>                          
                        </form>
                      )
                      }
                    </td>
                    <td className='text-right'>
                      {(val.month_number == 1 || mpr[key-1].admin_status == 1) && 
                        (val.admin_status == 1 ? 
                          <Link to={'#'} className="badge-warning badge p-2 text-white" data-toggle="modal" data-target="#TEModal" onClick={() => setTE(val.te)}>Technical Expert Comment</Link> :
                          (val.doc && val.submit_status != 1 &&
                            <FontAwesomeIcon icon={faTrashAlt} className='text-danger pointer' onClick={() => deleteMPR(val.id)} />
                          )
                        )
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
              :
              <tbody>
                <tr>
                  <td className='text-center'>Not activated</td>
                </tr>
              </tbody>
            }
          </table>
        </div>
      </div>     
      <TEModal />
      <DocModal />
    </>
  );
};

export default Lsit;